module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-row-own-right.d42f06e0.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-row-own-right.png
// module id = 3843
// module chunks = 11